<div class="alt-nav-icons">
    <ng-template ngFor let-link [ngForOf]="navConfig" let-i="index">
        <div class="alt-nav-icon"
            *ngIf="shouldShow(link) && !link.absolute"
            [ngClass]="{'active': selectedIdx === i}"
            (click)="handleNavigation(link.path)">
            <div class="alt-nav-background">
                <i class="nav-icon {{ link.icon }}"></i>
                <div class="nav-name">{{ link.name }}</div>
            </div>
        </div>
        <div class="alt-nav-icon"
            *ngIf="shouldShow(link) && link.absolute"
            [ngClass]="{'active': selectedIdx === i, 'no-hover': !brandId}"
            (click)="routeToExternalVersion(link.path, link.message)">
            <div class="alt-nav-background">
                <i class="nav-icon {{ link.icon }}"></i>
                <div class="nav-name">{{ link.name }}</div>
            </div>
        </div>
    </ng-template>
</div>

<div class="settings-menu-block">
    <div class="setting-icon" *ngIf="false">
        <i class="tce-icon-alerts"></i>
    </div>
    <ng-container *ngIf="false">
      <div class="setting-icon" *ngxPermissionsOnly="['SuperAdmin']" [matMenuTriggerFor]="gearIconMenu">
          <i class="tce-icon-settings"></i>
      </div>
    </ng-container>
    <mat-menu #gearIconMenu="matMenu"></mat-menu>

    <div class="setting-icon documentation-icon"
         (click)="openDocumentation()"
         [matTooltip]="'app.nav.documentation' | translate"
         matTooltipPosition="right">
        <mat-icon>help_outline</mat-icon>
    </div>

    <div class="setting-icon"
         [matMenuTriggerFor]="userIconMenu"
         [matTooltip]="'app.nav.logout' | translate"
         matTooltipPosition="right">
        <i class="tce-icon-user"></i>
        <img src="" style="display:none;">
    </div>

    <mat-menu #userIconMenu="matMenu">
        <button mat-menu-item (click)="logout()">Logout</button>
    </mat-menu>
</div>
